import React from "react";
import NavItem from "../components/navside/NavItem";

export default function NavSide() {
  return (
    <div className="fixed left-0 bg-slate-700 border-r-2 border-slate-500 w-40 h-screen">
      <NavItem href="/home/data" title="Data" />
      <NavItem href="/home/cluster" title="Cluster" />
    </div>
  );
}
